import React from 'react'
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({

  root: {
    width:"100%",
    marginBottom:"1.25rem",
    "& >p:last-child" : {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: "1.5rem",
      margin:0,
      marginTop:"1.25rem",
      color: "#212121",
    },
    "& >p:first-child" : {
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "1.375rem",
      lineHeight: "1.875rem",
      margin:0,
      color: "#212121"
    },
  }
});

interface ITitle {
  title:string;
  subTitle?:string
}

export function Title({title, subTitle}:ITitle) {
  const { root } = useStyles();
  return (
    <div className={root}>
       <p>
          {title}
       </p>
        {subTitle && <p>
          {subTitle}
        </p>  }   
    </div>
  )
}
